import {useHalState} from '@synako/haligator';
import {useClient} from '@/haligator-factory';
import {CatalogueMarketplace} from 'api-types/ffconnect';

export const useMarketplaceBrandColors = (
  marketplace_id: CatalogueMarketplace | undefined,
) => {
  const client = useClient();
  const marketplaceNav = marketplace_id
    ? client.follow('go:marketplace', {marketplace_id})
    : undefined;
  const {data: marketplaceData} = useHalState(marketplaceNav);
  return {
    couleur: marketplaceData?.couleur,
    textCouleur: marketplaceData?.text_couleur,
  };
};
